import React from 'react';
import V2StepDispatcher from 'builders/builderOpcode/configMode/v2/V2StepDispatcher';
import InlineLLMStep from './InlineLLMStep';
import InlineRAGStep from './InlineRAGStep';
import InlineAPIStep from './InlineAPIStep';
import InlineMemoryStep from './InlineMemoryStep';
import InlineToolStep from './InlineToolStep';
import InlineChooseStep from './InlineChooseStep';
import InlineSubflowStep from './InlineSubflowStep';
import InlineCallStep from './InlineCallStep';
import InlineParallelStep from './InlineParallelStep';

/**
 * dispatchInlineStep — routes a step kind to its DS-themed inline editor.
 *
 * Falls back to the legacy V2StepDispatcher for unknown kinds (`wait` is
 * the back-compat shim per A-0008.03; future kinds also land here until
 * an inline editor exists).
 *
 * Recursive: InlineParallelStep imports this same helper to render its
 * branches. Circular import is fine in React module-graph as long as the
 * function body (not the import side-effect) does the call.
 */
export default function dispatchInlineStep({
    step, onPatchStep, definitions = [], flows = [], oelContext
}) {
    if (!step || !step.kind) return null;
    switch (step.kind) {
        case 'llm': return <InlineLLMStep step={step} onPatchStep={onPatchStep} oelContext={oelContext} />;
        case 'rag': return <InlineRAGStep step={step} onPatchStep={onPatchStep} oelContext={oelContext} />;
        case 'api': return <InlineAPIStep step={step} onPatchStep={onPatchStep} oelContext={oelContext} />;
        case 'memory': return <InlineMemoryStep step={step} onPatchStep={onPatchStep} oelContext={oelContext} />;
        case 'tool': return <InlineToolStep step={step} onPatchStep={onPatchStep} oelContext={oelContext} />;
        case 'choose': return <InlineChooseStep step={step} onPatchStep={onPatchStep} definitions={definitions} flows={flows} oelContext={oelContext} />;
        case 'subflow': return <InlineSubflowStep step={step} onPatchStep={onPatchStep} flows={flows} oelContext={oelContext} />;
        case 'call': return <InlineCallStep step={step} onPatchStep={onPatchStep} definitions={definitions} oelContext={oelContext} />;
        case 'parallel': return <InlineParallelStep step={step} onPatchStep={onPatchStep} definitions={definitions} flows={flows} oelContext={oelContext} />;
        default:
            return (
                <div className="rounded-lg border bg-muted/10 p-3">
                    <div className="mb-2 text-[10.5px] uppercase tracking-wider text-amber-700">
                        kind <span className="font-mono">{step.kind}</span> falling back to legacy editor
                    </div>
                    <V2StepDispatcher
                        step={step}
                        onStepChange={onPatchStep}
                        definitions={definitions}
                        flows={flows}
                        oelContext={oelContext}
                    />
                </div>
            );
    }
}
